import React, {useEffect, useState} from 'react';
import Pdf from '../asset/View_Terms_Conditions.pdf';
import {Button, Link, Stack, styled, TextField, Typography,} from '@mui/material';
import {encryptCscValue, followRedirect, getEnvironment,} from '../util/util';
import {axiosAuth} from '../apis/main.api';
import Tooltip, {tooltipClasses} from '@mui/material/Tooltip';
import appConfig from '../config/appConfig';

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    '&:before': {
      border: '1px solid #ff0000',
    },
    color: '#f5f5f9',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: '220px',
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #ff0000',
  },
}));

function Csc({
  sessionId,
  accessToken,
  successRedirectUrl,
  nodeEnv,
  encryptionKey,
  setError,
}) {
  const [getCsc, setCsc] = useState('');
  const [getCscError, setCscError] = useState(false);
  const [getCscTooltipOpen, setCscTooltipOpen] = useState(false);
  const [disable, setDisable] = useState(false);

  const handleEncryptCsc = async () => {
    setDisable(true);
    const encryptedCsv = await encryptCscValue(getCsc, nodeEnv, encryptionKey);
    validateCsc(encryptedCsv);
  };

  const validateCsc = (encryptedCsv) => {
    axiosAuth.interceptors.request.use((config) => {
      config.baseURL = `${appConfig.config[getEnvironment(nodeEnv)]?.url}`;
      config.headers['Authorization'] = `Bearer ${accessToken}`;
      return config;
    });

    axiosAuth
      .post('transaction/stepup/csc', {
        csc_value: encryptedCsv,
        session_id: sessionId,
      })
      .then((response) => {
        followRedirect(response.data.validation_status, successRedirectUrl);
      })
      .catch((err) => {
        if (
          err &&
          err.response &&
          err.response.status == 401 &&
          err.response.data.validation_status == 'INVALID'
        ) {
          setDisable(false);
          setCscError(true);
          setCscTooltipOpen(true);
        } else {
          followRedirect(
            err.response.data.validation_status,
            successRedirectUrl
          );
        }
      });
  };

  return (
    <>
      <Typography variant='h9' sx={{ textAlign: 'left' }}>
        For your security, please enter the last 3 digits of the numbers shown
        on the back of your card inside the signature panel.
      </Typography>

      <Stack direction='row' spacing={4} sx={{ paddingLeft: '15px' }}>
        <HtmlTooltip
          placement='top-start'
          open={getCscTooltipOpen}
          title={
            <React.Fragment>
              <Typography variant='body2' color='red'>
                Please ensure the details entered are correct.
              </Typography>
            </React.Fragment>
          }
        >
          <TextField
            type='password'
            id='amexLast3Digits'
            variant='outlined'
            error={getCscError}
            label='Last 3 digits'
            inputProps={{ inputMode: 'numeric', maxLength: 3 }}
            onKeyPress={(event) => {
              const isNumber = /^\d$/.test(event.key);
              if (!isNumber) {
                event.preventDefault();
              }
            }}
            value={getCsc}
            onChange={(e) => {
              setCscTooltipOpen(false);
              setCsc(e.target.value);
            }}
          />
        </HtmlTooltip>
        <Button
          id='btnContinue'
          variant='contained'
          size='medium'
          sx={{
            borderRadius: '30px',
            width: '300px',
            color: 'white',
            backgroundColor: 'black',
            '&:hover': {
              backgroundColor: 'black',
            },
          }}
          onClick={handleEncryptCsc}
          disabled={disable || getCscTooltipOpen || getCsc.length !== 3}
        >
          Continue
        </Button>
      </Stack>

      <Stack direction='row' justifyContent="space-between" spacing={2}>
          <Link
            sx={{cursor: 'pointer' }}
            target='_blank'
            rel='noopener'
            href='https://www.americanexpress.com/us/company/privacy-center/online-privacy-disclosures/'
          >
            Online Privacy Policy
          </Link>
          <Link
            sx={{ cursor: 'pointer' }}
            target='_blank'
            rel='noopener'
            href={Pdf}
          >
            View Terms & Conditions
          </Link>

      </Stack>
    </>
  );
}

export default Csc;
